import { api } from "@/api";
import {
  ClearLeagueSuspensionsParams,
  ClearLeagueSuspensionsResponse,
} from "@/types/ApiResponses/League";

export const clearLeaguesSuspensions = async (
  params: ClearLeagueSuspensionsParams
): Promise<ClearLeagueSuspensionsResponse> => {
  const res = await api.client.delete(`/leagues-new/suspensions`, {
    params,
  });
  return res.data;
};
